import { render, staticRenderFns } from "./preset-artifact-tasks.vue?vue&type=template&id=bce32470&scoped=true"
import script from "./preset-artifact-tasks.vue?vue&type=script&lang=js"
export * from "./preset-artifact-tasks.vue?vue&type=script&lang=js"
import style0 from "./preset-artifact-tasks.vue?vue&type=style&index=0&id=bce32470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\wwwroot\\deepcityAI\\user-client-pc\\user-client-common-pc\\node_modules\\@vue\\vue-loader-v15\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce32470",
  null
  
)

export default component.exports